module.exports = __webpack_public_path__ + "img/account-multiple.1ea70c08.svg";